package ext

import pdflib.PDFPage
import pdflib.PDFPageDrawRectangleOptions
import pdflib.RGB

fun PDFPage.rect(
    x: Number? = null,
    y: Number? = null,
    width: Number? = null,
    height: Number? = null,
    color: RGB? = null,
) = drawRectangle(object : PDFPageDrawRectangleOptions {
    override var x: Number? = x
    override var y: Number? = y
    override var width: Number? = width
    override var height: Number? = height
    override var color: RGB? = color
})
